import { Button, Card, message } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { FormInput } from '../../Components/FormInputs';
import { LockOutlined } from '@ant-design/icons';
import { APIwithoutInterceptor } from "../../Axios/Axios";

import {
    getForgotPassword, getAuthenticationConfig,
    getValidationMessages, getPasswordExists
} from "../../Helpers/APIEndpoints/Endpoints";



const ForgotPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const type = location.state?.type;
    const username = location.state?.username;

    // This is for getting the user Context
    const getUserContext = () => {
        return {
            userAgent: navigator.userAgent,
            language: navigator.language,
            platform: navigator.platform,// NOSONAR : ignore
            screenResolution: `${window.screen.width}x${window.screen.height}`,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
    };

    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => setError(""), 3000);
            return () => clearTimeout(timer); // Cleanup to prevent memory leaks
        }
    }, [error]);

    const handleError = (messageText: string) => {
        setError(messageText);
        message.error(messageText);
    };



    const validateInputData = async (password: string, username: string) => {// NOSONAR : ignore
        try {
            // Fetch the authentication and password policy details
            const response = await APIwithoutInterceptor.post(getAuthenticationConfig);

            const data = await response.data;

            // Parse the AuthType JSON string
            const parsedData = JSON.parse(data.data);

            // Extract the passwordPolicy
            const passwordPolicy = parsedData.security.passwordPolicy;


            // this API call is for the message valdiation
            const message = await APIwithoutInterceptor.post(getValidationMessages);

            const messageresponse = await message.data;

            const passwordresponse = await APIwithoutInterceptor.post(getPasswordExists, {
                loginId: username,
                password: password
            });

            const responsedata = await passwordresponse.data;
            if (responsedata.data.isPasswordMatched) {
                return messageresponse.resetPasswordPolicyViolation;
            }

            // Validate password based on the policy
            if (password) {

                if (password.length < passwordPolicy.minLength) {
                    return messageresponse.passwordPolicyViolation;
                }

                if (password.length > passwordPolicy.maxLength) {
                    return messageresponse.passwordPolicyViolation;
                }

                if (passwordPolicy.requireUppercase && !/[A-Z]/.test(password ?? "")) {
                    return messageresponse.passwordPolicyViolation;
                }

                if (passwordPolicy.requireLowercase && !/[a-z]/.test(password ?? "")) {
                    return messageresponse.passwordPolicyViolation;
                }

                if (passwordPolicy.requireDigit && !/\d/.test(password ?? "")) {
                    return messageresponse.passwordPolicyViolation;
                }

                if (
                    passwordPolicy.requireSpecialCharacter &&
                    !new RegExp(`[${passwordPolicy.allowedSpecialCharacters.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')}]`).test(password ?? "")
                ) {
                    return messageresponse.passwordPolicyViolation;
                }
            }

            // If all validations pass
            return null; // No error
        } catch (error) {
            console.log(error)
            return "Error validating password. Please try again.";
        }
    };

    useEffect(() => {
        if (!username) {
            message.error('You cannot directly access this page. Please enter your username first.');
            navigate('/login', { state: { type: type } });
        }
    }, [username]);

    const validatePassword = async () => {
        if (password !== confirmPassword) {
            handleError('Passwords do not match');
            return;
        }
        const error = await validateInputData(confirmPassword, username);
        if (error) {
            handleError(error);
            return;
        } else {
            setError(""); // Clears the error when input is correct
        }

        const userContext = getUserContext();

        try {
            const response = await APIwithoutInterceptor.post(getForgotPassword, {
                loginId: username ?? '',
                password: confirmPassword ?? '',

                ...userContext,
            });
            const data = await response.data;
            if (data.message == "OK") { //response.ok && 
                message.success('Password changed sucessfully.');
                setError('');
                navigate('/login', { state: { type: type } });
            }

        }
        catch (error) {
            console.log(error)
            handleError("Error validating password. Please try again.");
        }


    }

    return (
        <div className="login-container">
            <Card className="login-card">
                <h1 className="login-title">Forgot Password</h1>
                <div className="form-group text-center mt-3">
                    <FormInput
                        name='password'
                        label='Password'
                        placeholder='Password'
                        inputType="password"
                        value={password}
                        onChange={(e: any) => setPassword(e.target.value)}
                        prefix={<LockOutlined />}
                        widthSize="large"
                        rules={[
                            { required: true, message: "Password is required" },
                        ]}>
                    </FormInput>
                </div>
                <div className="form-group text-center mt-3">
                    <FormInput
                        name='Confirm Password'
                        label='Confirm Password'
                        placeholder='Confirm Password'
                        inputType="password"
                        value={confirmPassword}
                        onChange={(e: any) => setConfirmPassword(e.target.value)}
                        prefix={<LockOutlined />}
                        widthSize="large"
                        rules={[
                            { required: true, message: "Confirm Password is required" }
                        ]}>
                    </FormInput>
                </div>
                {error && <div className="login-error"><span style={{ color: "red" }}>{error}</span></div>}
                <Button type="primary" className="login-button" onClick={validatePassword}>
                    Submit
                </Button>
            </Card>
        </div>
    );
}
export default ForgotPassword;